import {TranslateService} from '@ngx-translate/core';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {BasicBar} from '../../+postpayroll/check/key-metrics/charts/column/basic-bar';
import {Chart, ChartData} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

import {DashboardChartUtils} from './dashboard-chart.utils';

export class ValidationPlanFamilyChart extends BasicBar {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService) {
    const params = chartBox.params[Object.keys(chartBox.params)[0]];
    const chart: Chart = ChartUtils.getEmptyChart();

    params.forEach((element: ChartBoxElement) => {
      chart.data.push({
        category: element.name,
        name: '',
        value: element.value,
        metadata: element.link
      });
    });
    chart.type = chartBox.cardType;
    super(chart, translate, localization, true);

    this.series.forEach((serie: any) => {
      serie.data = serie.data.map((value: number, index: number) => {
        return this.chart.data
          .find((chartData: ChartData) => chartData.value === value
            && chartData.category === this.categories[index]) || value;
      });
    });
    this.tooltip.formatter = (element: any) =>
      `${element.marker} ${this.translate.instant(element.name)}: ${element.value}`;
    this.animation = true;
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);
    this.color = DashboardChartUtils.standardColors();
  }
}
